







"use strict";

const {ajax} = require("./ajax-util");

function loadScript(url) {
    
    let hash = $("#hash").attr("value");
    let postfix = hash ? ("?" + hash) : "";
    url += postfix;
    
    return ajax({
        url,
        type: "GET",
        contentType: "text/javascript"
    }).then(script => {
        eval(script); 
    });
}




class Localizer {
    





    


























    constructor(option) {
        this._urlBuilder = (option && option.urlBuilder) ||
            function (lang) {
                return "js/lang/lang-" + lang + ".js";
            };
        this._symbol = (option && option.symbol) || "%";

        let defaultLang = (option && option.defaultLang) || "en";
        let lang = (option && option.lang)
            || (navigator && (
                (navigator.languages && navigator.languages[0])
                    || navigator.language
                    || navigator.userLanguage
                    || navigator.browserLanguage))
            || defaultLang;
        this._lang = lang;

        if (option && option.supportedLang) {
            this._lang = option.supportedLang[lang];
            if (!this._lang) {
                let lang2 = lang.split("-")[0];
                if (lang2 !== lang) {
                    this._lang = option.supportedLang[lang2];
                }
            }
            this._lang = this._lang || "en";
        }

        let readyHandler = (option && option.readyHandler)
            || (require("./ready-handler")).defaultReadyHandler;
        readyHandler.addState("l10n");
        readyHandler.addBeforeVisibleCallback(() => {
            if (!window.localizedTextMessages) {
                throw new Error(`failed to load lang from ${url}`);
            }
            this.msg = window.localizedTextMessages;
        });

        let url = this._urlBuilder(this._lang);
        loadScript(url).then(() => {
            readyHandler.changeState("l10n");
        });
    }

    



























    format(formatStr, args = null) {
        let str = "";
        let prevIdx = 0;
        let reg = RegExp("(\\\\?" + this._symbol + ")(\\((\\*?)([^,()]+)(,([^)]+))?\\))", "g");
        let ret = reg.exec(formatStr);
        if (ret) {
            do {
                str += formatStr.slice(prevIdx, ret.index);
                prevIdx = ret.index + ret[0].length;
                if (ret[1][0] === "\\") { 
                    str += ret[2];
                } else {
                    let star = ret[3] === "*";
                    let keys = ret[4].split(".");
                    let v = this._extract(keys, args);
                    if (v === undefined || v === null) {
                        v = this._extract(keys, this.msg);
                    }
                    if (star) {
                        v = this.msg[v];
                    }
                    if (ret[6]) {
                        let args2 = eval(ret[6]);
                        v = this.format(v, args2);
                    }
                    if (v === undefined || v === null) {
                        return null;
                    }
                    str += v;
                }
            } while ((ret = reg.exec(formatStr)) !== null);
            if (prevIdx < formatStr.length) {
                let substr = formatStr.slice(prevIdx, formatStr.length);
                if (!substr) {
                    return null;
                }
                str += substr;
            }
            return str;
        } else {
            return this.format(this._symbol + "(" + formatStr + ")", args);
        }
    }

    _extract(keys, msg) {
        if (!Array.isArray(keys)) {
            keys = keys.split(".");
        }
        return keys.reduce(((v, key) => v ? v[key] : undefined), msg);
    }

    

















    localize(elem) {
        this._localize($(elem));
    }

    




    localizeOne(elem) {
        this._localizeOne($(elem));
    }

    _localize(elem) {
        this._localizeOne(elem);
        elem.children().each((i, child) => {
            this.localize(child);
        });
    }

    _localizeOne(elem) {
        let attrs = elem.get(0).attributes;
        let attrLen = attrs.length;
        let delAttrs = [];
        for (let i = 0; i < attrLen; ++i) {
            let attr = attrs[i];
            if (attr.name.indexOf("t-") === 0) {
                let name = attr.name.slice(2);
                if (name === "t") {
                    elem.text(this.format(attr.value || elem.text() || elem.attr("id")));
                } else if (name === "h") {
                    elem.html(this.format(attr.value || elem.text() || elem.attr("id")));
                } else {
                    elem.attr(name, this.format(attr.value || elem.attr("id")));
                }
                delAttrs.push(attr.name);
            }
        }
        let delAttrLen = delAttrs.length;
        for (let i = 0; i < delAttrLen; ++i) {
            elem.removeAttr(delAttrs[i]);
        }
    }
}

module.exports = Localizer;

